//
//
//

import _ from 'underscore'
import Vue from 'vue'

export default {
  props: {
    value: {
      default: ''
    },
    size: {
      default: 'mini'
    }
  },
  data: function () {
    return {
      currentValue: Vue.filter('price')(this.value)
    }
  },
  watch: {
    value: {
      handler (val) {
        if (this.currentValue !== val) {
          if (_.isString(val)) {
            let numReg = /^[0-9]+$/
            let floatReg = /^[0-9]+\.?[0-9]+?$/
            if ((numReg.test(val) || floatReg.test(val)) && ((parseFloat(val)+'') === val)) {
              this.currentValue = Vue.filter('price')(val)
            }
          } else {
            this.currentValue = Vue.filter('price')(val)
          }
        }
      }
    },
    currentValue: {
      handler (val) {
        if (this.value !== val) {
          let v = val * 100
          this.$emit('input', v)
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
  }
}
